import React, { useState, useId } from "react";
import "./ReportUserModal.css";

// Mirrors the mobile ReportUserModal reasons so triage in the admin Reports
// panel is consistent regardless of where the report originated.
const REPORT_REASONS = [
  "Spam or scam",
  "Harassment or abusive language",
  "Fake listing or fraud",
  "Inappropriate content",
  "Other",
];

export default function ReportUserModal({ visible, userName, onClose, onSubmit }) {
  const [reason, setReason] = useState(null);
  const [details, setDetails] = useState("");
  const titleId = useId();
  const detailsId = useId();

  if (!visible) return null;

  const close = () => { setReason(null); setDetails(""); onClose(); };

  return (
    <div className="modal-overlay" onClick={close}>
      <div
        className="modal report-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="report-modal-heading">
            <h3 id={titleId}>Report {userName || "user"}</h3>
            <p className="report-modal-sub">Your report is confidential. Our team will review this conversation.</p>
          </div>
          <button type="button" className="btn-icon" onClick={close} aria-label="Close">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <span className="field-label" id={`${titleId}-reason`}>Reason</span>
            <div className="report-reasons" role="group" aria-labelledby={`${titleId}-reason`}>
              {REPORT_REASONS.map((r) => (
                <button
                  key={r}
                  type="button"
                  className={`report-reason ${reason === r ? "selected" : ""}`}
                  aria-pressed={reason === r}
                  onClick={() => setReason(r)}
                >
                  <span className={`report-radio ${reason === r ? "on" : ""}`} aria-hidden="true" />
                  {r}
                </button>
              ))}
            </div>
          </div>

          <div className="field">
            <label className="field-label" htmlFor={detailsId}>
              Details <span className="muted">(optional)</span>
            </label>
            <textarea
              id={detailsId}
              className="textarea report-details"
              placeholder="Anything that helps our team review this"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              maxLength={500}
              rows={3}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={close}>Cancel</button>
          <button
            type="button"
            className="btn-danger"
            disabled={!reason}
            onClick={() => { onSubmit(reason, details.trim()); close(); }}
          >
            Submit report
          </button>
        </div>
      </div>
    </div>
  );
}
